<template>
  <ModalComponent
        name="imagen-panoramica"
        :title="title"
        v-on:close="() => close(false)"
    >
      <iframe height="400" allowfullscreen style="border-style:none; width: 100%" :src="src"></iframe>
  </ModalComponent>
</template>

<script>
import ModalComponent from "@/components/backend/components/ModalComponent";

export default {
    props: ['title', 'url'],
    data() {
        return {
            src: 'https://cdn.pannellum.org/2.5/pannellum.htm#panorama=' + this.url + '?x-request=html&autoLoad=true'
        };
    },
    methods: {
        close(actualizar) {
            this.$emit('close', 'imagen-panoramica')
        },
    },
    components: { ModalComponent },
};
</script>
